/* eslint-disable react/button-has-type */
import * as React from 'react';

import { FlameTheme } from '@lightspeed/flame/Core';

import { translate } from 'pages/utils/translate';

export interface ListViewData {
  giftCardsInfo: { code: string; name: string }[];
}
export const GiftCardList = ({ viewData }: { viewData: ListViewData }) => {
  return (
    <FlameTheme>
      <span id="selectGiftCardLabel">{translate('Select Correct Gift Card')}</span>
      <table
        className="payments_list"
        style={{ width: '100%', border: 0 }}
        cellPadding="0"
        cellSpacing="0"
      >
        <tbody>
          {viewData.giftCardsInfo
            .filter((giftCard) => giftCard.code)
            .map((giftCard) => (
              <React.Fragment key={giftCard.code}>
                <tr>
                  <td style={{ paddingBottom: '0px' }}>
                    <i>{giftCard.name}</i>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ fontWeight: 'bold', marginRight: '2px' }}
                      className="gui-def-button giftCardButton"
                      data-code={giftCard.code}
                    >
                      {giftCard.code}
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          <tr>
            <td>
              <button id="selectGiftCardCancel" className="gui-def-button">
                {translate('Cancel')}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </FlameTheme>
  );
};
